import React from 'react';
import { cn } from '@/lib/utils';

export function PlaylistCardSkeleton() {
  return (
    <div className="bg-white rounded-[18px] overflow-hidden border border-[hsl(var(--border))]">
      {/* Thumbnail Skeleton */}
      <div className="relative w-full h-[150px] md:h-[180px] overflow-hidden">
        <div 
          className={cn(
            'w-full h-full',
            'bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200',
            'bg-[length:400%_100%]',
            'animate-[shimmer_2s_ease-in-out_infinite]'
          )}
        />
      </div>

      {/* Content Skeleton */}
      <div className="p-4 space-y-3">
        {/* Title Skeleton */}
        <div 
          className={cn(
            'h-4 w-[70%] rounded-md',
            'bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200',
            'bg-[length:400%_100%]',
            'animate-[shimmer_2s_ease-in-out_infinite]'
          )}
        />
        
        {/* Meta Skeleton */}
        <div 
          className={cn(
            'h-3 w-[50%] rounded-md',
            'bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200',
            'bg-[length:400%_100%]',
            'animate-[shimmer_2s_ease-in-out_infinite]'
          )}
        />
      </div>
    </div>
  );
}

export function PlaylistGridSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 gap-y-6 md:gap-y-8">
      {Array.from({ length: count }).map((_, index) => (
        <PlaylistCardSkeleton key={index} />
      ))}
    </div>
  );
}
